<template>
    <div class="Administration">
        <el-form :model="ruleForm" ref="ruleForm" label-width="100px" style="overflow: hidden;" class="demo-ruleForm">
            <el-row>
                <el-col :span="6">
                    <el-form-item label="开始日期" prop="beginDate">
                        <el-date-picker
                            @change="startTime1"
                            v-model="ruleForm.beginDate"
                            align="right"
                            type="date"
                            placeholder="选择开始日期"
                            format="yyyy-MM-dd HH:mm:ss"
                        ></el-date-picker>
                    </el-form-item>
                </el-col>
                <el-col :span="6">
                    <el-form-item label="结束日期" prop="endDate">
                        <el-date-picker
                            @change="endTime1"
                            v-model="ruleForm.endDate"
                            align="right"
                            type="date"
                            placeholder="选择结束日期"
                            format="yyyy-MM-dd HH:mm:ss"
                        ></el-date-picker>
                    </el-form-item>
                </el-col>
                <el-col :span="6">
                    <el-form-item label="来源" prop="sourceArea">
                        <el-select v-model="ruleForm.sourceArea" placeholder="请选择">
                            <el-option
                                v-for="item in sourceList"
                                :key="item.value"
                                :label="item.label"
                                :value="item.value"
                            ></el-option>
                        </el-select>
                    </el-form-item>
                </el-col>
                <el-col :span="6">
                    <el-form-item label="店铺" prop="sellerId">
                        <el-select v-model="ruleForm.sellerId" placeholder="请选择" filterable @change="changeSelect" value-key="sellerId">
                            <el-option
                                v-for="item in shop_stationList"
                                :key="item.id"
                                :label="item.shop_name"
                                :value="item"
                            ></el-option>
                        </el-select>
                    </el-form-item>
                </el-col>
            </el-row>
            <el-row type="flex" justify="space-between">
                <div>
                    <span>币种：</span>
                    <span
                        class="Detailedspan"
                        v-for="(item, i) in currency"
                        :key="i"
                        @click="Choice(item.val)"
                        :class="{ active: ruleForm.currencyCode === item.val }"
                    >
                        {{ item.name }}
                    </span>
                </div>
                <el-col :span="5">
                    <el-form-item prop="searchInput">
                        <!-- <el-input v-model="ruleForm.searchInput" placeholder="全字段搜索" style="width: 70%;"></el-input> -->
                        <el-button type="primary" @click="getCreditCardIncomeList()">搜索</el-button>
                        <el-button type="primary" @click="resetFprm('ruleForm')">重置</el-button>
                    </el-form-item>
                </el-col>
            </el-row>
            <!-- <el-col :span="13" class="line-height4">
                <el-col :span="2">币种：</el-col>
                <el-col :span="20">
                    <span
                        class="Detailedspan"
                        v-for="(item, i) in currency"
                        :key="i"
                        @click="Choice(item.val)"
                        :class="{ active: Choicetype === item.val }"
                    >
                        {{ item.name }}
                    </span>
                </el-col>
            </el-col> -->
            <!-- <el-col :span="11"></el-col> -->
        </el-form>
        <el-row>
            <el-table :data="tableData" :header-cell-style="headClass" border style="width: 100%">
                <el-table-column prop="time" label="入账时间" align="center">
                    <template slot-scope="scope">
                        <p>{{ scope.row.fundtransferdate }}</p>
                    </template>
                </el-table-column>
                <el-table-column prop="source" label="来源" align="center">
                    <template slot-scope="scope">
                        <p v-if="scope.row.sourceArea === 'JP'">日本</p>
                        <p v-if="scope.row.sourceArea === 'EUR'">欧洲</p>
                        <p v-if="scope.row.sourceArea === 'NA'">北美</p>
                    </template>
                </el-table-column>
                <el-table-column label="店铺名称" align="center">
                    <!-- <template slot-scope="scope">
            <el-collapse v-for="(ele,i) in scope.row.shopList" :key="i">
              <el-collapse-item :title="ele.shop">
                <div class="line-height" v-for="(item,i) in ele.station" :key="i">{{item}}</div>
              </el-collapse-item>
            </el-collapse>
                    </template>-->
                    <template slot-scope="scope">
                        <p>{{ scope.row.seller.shop_name }}</p>
                    </template>
                </el-table-column>
                <el-table-column prop="currency" label="币种" align="center">
                    <template slot-scope="scope">
                        <p>{{ scope.row.originaltotalCurrencycode }}</p>
                    </template>
                </el-table-column>
                <el-table-column prop="Amount" label="金额" align="center">
                    <template slot-scope="scope">
                        <p>{{ scope.row.originaltotalCurrencyamount }}</p>
                    </template>
                </el-table-column>
                <el-table-column align="center">
                    <template slot="header">
                        人民币
                        <el-popover trigger="hover" placement="top">
                            <p>该金额为当前汇率转换的人民币数额</p>
                            <i class="iconfont icon-tishi" slot="reference"></i>
                        </el-popover>
                    </template>
                    <template slot-scope="scope">
                        {{ calcRMB(scope.row) }}
                    </template>
                 
                </el-table-column>
                <el-table-column prop="type" label="状态" align="center">
                    <template slot-scope="scope">
                        <p>{{ scope.row.fundtransferstatus }}</p>
                    </template>
                </el-table-column>
            </el-table>
            <div class="pagination-container">
                <el-pagination
                    @size-change="handleSizeChange"
                    @current-change="handleCurrentChange"
                    :current-page="page"
                    :page-sizes="[20, 50, 100, 200]"
                    :page-size="size"
                    layout="total, sizes, prev, pager, next, jumper"
                    :total="total"
                ></el-pagination>
            </div>
        </el-row>
    </div>
</template>

<script>
import { ajaxPost, Baseurl } from "../../../api/api/api";
export default {
    name: "Detailed",
    data() {
        return {
            headClass: this.common.headClass,
            Choicetype: "0",
            tableData: [
                // {
                //   time: "",
                //   source: "",
                //   shopList: [
                //     {
                //       shop: "HTTY",
                //       station: ["日本站", "加拿大站", "墨西哥站"]
                //     },
                //     {
                //       shop: "HTTY",
                //       station: ["美国站", "加拿大站", "墨西哥站"]
                //     },
                //     {
                //       shop: "HTTY",
                //       station: ["英国站", "法国站", "德国站"]
                //     }
                //   ],
                //   currency: "",
                //   Amount: "",
                //   CNY: "",
                //   type: ""
                // }
            ],
            ruleForm: {
                // startString: "",
                // endString: "",
                // source: "",
                // shopName: "",
                // searchInput: "",

                sellerId: '',
                beginDate: '',
                endDate: '',
                currencyCode: '',
                sourceArea: '',
            },
            sourceList: [
                {
                    value: "",
                    label: "全部",
                },
                {
                    value: "NA",
                    label: "亚马逊-北美",
                },
                {
                    value: "EUR",
                    label: "亚马逊-欧洲",
                },
                {
                    value: "JP",
                    label: "亚马逊-日本",
                },
            ],
            shop_stationList: [],
            currency: [
                {
                    val: "",
                    name: "全部",
                },
                {
                    val: "USD",
                    name: "美元",
                },
                {
                    val: "EUR",
                    name: "欧元",
                },
                {
                    val: "GBP",
                    name: "英镑",
                },
                {
                    val: "JPY",
                    name: "日元",
                },
                {
                    val: "AUD",
                    name: "澳元",
                },
                {
                    val: "CAD",
                    name: "加元",
                },
                {
                    val: "SGD",
                    name: "新加坡元",
                },
                {
                    val: "INR",
                    name: "印尼盾（卢比）",
                },
                {
                    val: " ",
                    name: "迪拉姆",
                },
                {
                    val: "  ",
                    name: "兹罗提",
                },
                {
                    val: "   ",
                    name: "港币",
                },
            ],
            UserInfo: {},
            page: 1,
            size: 20,
            total: 0,
            exchangeRateList: {},
            shopIds: []
        };
    },
    created() {
        this.UserInfo = JSON.parse(localStorage.getItem("role"));
        this.getExchangeRateList()
        this.getAllSellerAndCountry();
    },
    methods: {
        // 获取汇率列表
        getExchangeRateList() {
            ajaxPost(Baseurl + "rateController/getRate").then(res => {
                const { data: responseData } = res;
                if (responseData.code === 200) {
                    const { data } = responseData;
                    this.exchangeRateList = data;
                    // console.log("汇率数据：", this.exchangeRateList);
                }
            });
        },
        getCreditCardIncomeList() {
            var parameter = {
                page: this.page,
                size: this.size,
                ...this.ruleForm,
                sellerId: this.shopIds
                // companyId: this.UserInfo.company_id,
                // searchStr: this.search,
                // startString: this.ruleForm.startString,
                // endString: this.ruleForm.endString,
                // shopName: this.ruleForm.shopName,
                            
            };
            ajaxPost(Baseurl + "financesController/selectFinancialEventList", parameter).then(res => {
                const { code, data } = res.data
                if (code === 200) {
                    this.tableData = data.list;
                    this.total = data.total;
                }
            });
        },
        async getAllSellerAndCountry() {
            const API = Baseurl + "sellerController/selectSellerByPayMent";
            const { rid, company_id, system } = this.UserInfo;
            const paramsData = { rid, system, companyId: company_id };
            const {
                data: { code, data },
            } = await ajaxPost(API, paramsData);
            if (code === 200) {
                // const handleData = data.reduce((total, item) => [...total, ...item.map(key => key.countryMarks)], []);
                this.shop_stationList = data;
                if (this.shop_stationList.length) {
                    this.shopIds = this.shop_stationList.map(item => item.sellerId)
                    // this.ruleForm.sellerId = this.shopIds
                    this.getCreditCardIncomeList();
                }
            }
        },
        startTime1(val) {
            var d = new Date(val);
            var datetime = d.getFullYear() + "-" + (d.getMonth() + 1) + "-" + d.getDate() + " 00:00:00";
            this.ruleForm.startString = datetime;
            console.log(this.ruleForm.startTimeString);
        },
        endTime1(val) {
            var d = new Date(val);
            var datetime = d.getFullYear() + "-" + (d.getMonth() + 1) + "-" + d.getDate() + " 23:59:59";
            this.ruleForm.endString = datetime;
            console.log(this.ruleForm.endTimeString);
        },
        search() {
            //搜索
        },
        resetFprm(formName) {
            this.$refs[formName].resetFields();
            this.shopIds = this.shop_stationList.map(item => item.sellerId)
            this.getCreditCardIncomeList();
        },
        Choice(val) {
            this.ruleForm.currencyCode = val;
            // this.Choicetype = val;
        },
        handleSizeChange(val) {
            this.size = val
            this.getCreditCardIncomeList();
        },
        handleCurrentChange(val) {
            this.page = val
            this.getCreditCardIncomeList();
        },
        calcRMB(row) {
            const rateData = this.exchangeRateList.find(item => item.currencyCode === row.beginningbalanceCurrencycode)
            return (rateData.exchangeRate * row.originaltotalCurrencyamount).toFixed(2) || 0
        },
        changeSelect(item) {
            this.shopIds = [item.sellerId]
        }
    },
};
</script>

<style lang="scss" scoped>
/deep/ {
    .el-collapse {
        border-top: 1px solid #fff;
        border-bottom: 1px solid #fff;
    }
    .el-collapse-item__header {
        border-bottom: 1px solid #fff;
    }
    .el-collapse-item__wrap {
        border-bottom: 1px solid #fff;
    }
    .el-collapse-item__content {
        padding-bottom: 0px;
    }
}
.line-height {
    line-height: 30px;
}
.line-height4 {
    line-height: 40px;
}
.Detailedspan {
    margin-right: 5px;
    padding: 2px 8px;
    border-radius: 4px;
    cursor: pointer;
}
.active {
    background-color: rgb(43, 110, 236);
    color: #fff;
}
.Administration {
    padding-bottom: 72px;
}
.pagination-container {
    width: 1660px;
    padding: 20px;
    position: fixed;
    right: 0;
    bottom: 0;
    background: #fff;
    z-index: 999;
    .el-pagination {
        display: flex;
        justify-content: center;
    }
}
</style>
